export const SIZE_DOTS = {
  XXS: 'xxs',
  XS: 'xs',
}
